import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Spinner } from "../ui";
import Logo from "../components/site/Logo";
import SiteBackdrop from "../components/site/SiteBackdrop";
import { attachCampaignVisitor, openCampaign } from "../utils/campaign";

// Nobody waits here longer than this: a slow or failed lookup goes home (the
// request still finishes in the background and is counted).
const MAX_WAIT_MS = 4000;

// tarbaa.com/go/<slug>: a campaign link. Count the click, credit the account
// if the visitor is already signed in, then replace this page with wherever
// the link points. A discount link lands on /pricing?code=X, and
// DiscountCapture (AppProviders) keeps the code as for any shared link.
// ?test=1 opens the link without counting it.
const CampaignRedirect = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const test = searchParams.get("test") === "1";
  const navigate = useNavigate();

  useEffect(() => {
    let done = false;
    const go = (destination) => {
      if (done) return;
      done = true;
      navigate(destination || "/", { replace: true });
    };
    const timer = setTimeout(() => go("/"), MAX_WAIT_MS);
    openCampaign(slug, { test }).then((res) => {
      attachCampaignVisitor();
      clearTimeout(timer);
      go(res?.destination);
    });
    return () => {
      done = true;
      clearTimeout(timer);
    };
  }, [slug, test, navigate]);

  return (
    <div
      dir="rtl"
      className="relative isolate min-h-screen overflow-hidden bg-header font-sans text-white flex flex-col items-center justify-center gap-6 px-4"
    >
      <SiteBackdrop />
      <Logo className="w-16 h-16" />
      <div
        role="status"
        aria-live="polite"
        className="flex items-center gap-3 text-white/80"
      >
        <Spinner size={22} className="text-primary" />
        <span className="font-semibold">لحظات...</span>
      </div>
    </div>
  );
};

export default CampaignRedirect;
